import { render, staticRenderFns } from "./additem.vue?vue&type=template&id=2d42ce4c"
import script from "./additem.vue?vue&type=script&lang=js"
export * from "./additem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports